import { render, staticRenderFns } from "./ContractAdd.vue?vue&type=template&id=644745d8&scoped=true&"
import script from "./ContractAdd.vue?vue&type=script&lang=js&"
export * from "./ContractAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644745d8",
  null
  
)

export default component.exports